<!--
    USE IN: Transfers
-->
<script>
    import R from "../lib/requests";
    import {clickOutside} from '../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import ControlLoader from "../components/ControlLoader.svelte";

    export let id = 'location';
    export let location = null;
    export let locations = null;
    export let placeholder = '';
    export let css = '';

    let locationId = null;
    let timer;
    let results = [];
    let listIndex = -1;
    let showDropdown = false;
    let loading = false;

    const dispatch = createEventDispatcher();

    const emptyLocation = (name = '') => {
        return {
            id: 0,
            hotel_id: 0,
            name,
            parent_name: '',
            is_local: 1,
        }
    }

    const search = () => {
        const onSuccess = result => {
            results = result;
            loading = false;
            openDropdown();
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        let data = {
            name: location.name,
            is_local: 1,
            is_active: 1,
        }
        R.handle(R.location.index, data, onSuccess, onFailure);
    }

    const onFocusOut = () => {
        if (locationId != location.id) {
            locationId = location.id;
            dispatch("change", location);
        }
    }

    const onKeyDown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter') {
                event.preventDefault();
                if (timer) {
                    clearInterval(timer);
                }
                if (listIndex > -1) {
                    onSelect(results[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyUp = (event) => {
        if (location.name != event.target.value) {
            if (timer) {
                clearInterval(timer);
            }

            if (event.target.value.length) {
                location = emptyLocation(event.target.value.trim());

                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
            }
        }
    }

    const clear = () => {
        location = emptyLocation();
        locationId = null;
        dispatch("change");
    }

    const onSelect = (item) => {
        location = item;
        dispatch("change", location);
        closeDropdown();
    }

    const openDropdown = () => {
        showDropdown = true;
    }

    const closeDropdown = () => {
        showDropdown = false;
    }

    const onSelectChange = () => {
        location = locations.find(x => x.id == locationId);
        dispatch("change", location);
    }

    if (location == null) {
        location = emptyLocation();
    } else {
        locationId = location.id;
    }
</script>

{#if locations}
    <div class="form-item">
        <select class="form-select" bind:value="{ locationId }" on:change={ onSelectChange }>
            {#each locations as item}
                <option value="{ item.id }">{ item.name }</option>
            {/each}
        </select>
        {#if location && location.parent_name}
            <div class="form-item-info">
                { location.parent_name }
            </div>
        {/if}
    </div>
{:else}
    <div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
        <div class="form-item">
            <input type="text" class="form-control {css}" id="{ id }" value="{ location.name }"
                   on:keydown="{ onKeyDown }"
                   on:keyup="{ onKeyUp }"
                   on:focusout="{ onFocusOut }"
                   autocomplete="off"
                   {placeholder}>

            <ControlLoader {loading}/>
            {#if location && location.parent_name}
                <div class="form-item-info">
                    { location.parent_name }
                </div>
            {/if}
        </div>
        {#if showDropdown}
            {#if results.length}
                <ul class="dropdown">
                    {#each results as item, index}
                        <li class="dropdown-item pointer" class:selected="{ listIndex === index }"
                            on:click="{ () => onSelect(item) }">
                            { item.name }
                        </li>
                    {/each}
                </ul>
            {/if}
        {/if}
    </div>
{/if}